import Swiper from 'swiper/swiper-bundle'

document.addEventListener('DOMContentLoaded', () => {
  const sliderWrappers = document.querySelectorAll('.mtt-case-slider')

  if (sliderWrappers.length > 0) {
    sliderWrappers.forEach(sliderWrapper => {
      const swiperElement = sliderWrapper.querySelector('.mtt-case-slider__swiper')
      const pagination = sliderWrapper.querySelector('.mtt-case-slider__pagination .swiper-pagination')
      const nextButton = sliderWrapper.querySelector('.swiper-next')
      const prevButton = sliderWrapper.querySelector('.swiper-prev')

      const swiperOptions = {
        speed: 1000,
        spaceBetween: 100,
        slidesPerView: 1,
        loop: false,
        parallax: true,
        grabCursor: true,
        autoplay: {
          delay: 4000,
          disableOnInteraction: true,
        },
        pagination: {
          el: pagination,
          clickable: true,
        },
        navigation: {
          nextEl: nextButton,
          prevEl: prevButton
        }
      }

      const swiper = new Swiper(swiperElement, swiperOptions)

      swiperElement.addEventListener('mouseenter', function () {
        swiper.autoplay.stop();
      })

      swiperElement.addEventListener('mouseleave', function () {
        swiper.autoplay.start();
      })
    })
  }
})